import { HOP_TIERS, type HopTierId, type MaterializationRequest } from "../api/types";

export type ZeroCommand = {
  title: string;
  detail: string;
  command: string;
};

const shellQuote = (value: string): string => `'${value.replaceAll("'", "'\\''")}'`;

const origin = (): string => window.location.origin.replace(/\/$/, "");

const tierPrice = (tier: HopTierId): number =>
  HOP_TIERS.find((item) => item.id === tier)?.priceUsd ?? HOP_TIERS[1].priceUsd;

export const buildZeroSearchCommand = (tier: HopTierId, query: string): ZeroCommand => ({
  title: "Run With Zero",
  detail: `${tier} graph search · max $${tierPrice(tier).toFixed(3)}`,
  command: [
    `zero fetch ${shellQuote(`${origin()}/v1/search/${tier}`)} \\`,
    `  -d ${shellQuote(JSON.stringify({ query }))} \\`,
    `  --max-pay ${tierPrice(tier).toFixed(3)} --json`,
  ].join("\n"),
});

export const buildZeroVaultListCommand = (): ZeroCommand => ({
  title: "Vault Proof",
  detail: "zero-amount wallet proof · private materializations",
  command: `zero fetch ${shellQuote(`${origin()}/v1/me/materializations`)} --json`,
});

export const buildZeroVaultSaveCommand = (request?: MaterializationRequest): ZeroCommand => ({
  title: "Save With Zero",
  detail: "zero-amount wallet proof · owner is the paying/proving wallet",
  command: request
    ? [
        `zero fetch ${shellQuote(`${origin()}/v1/me/materializations`)} \\`,
        `  -d ${shellQuote(JSON.stringify(request))} --json`,
      ].join("\n")
    : [
        `zero fetch ${shellQuote(`${origin()}/v1/me/materializations`)} \\`,
        "  -d @materialization.json --json",
      ].join("\n"),
});
